/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CorporateGroupModel } from '../../models/corporate-group-model';

export interface GetApiCorporategroupV1Id$Json$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiCorporategroupV1Id$Json(http: HttpClient, rootUrl: string, params: GetApiCorporategroupV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateGroupModel>> {
  const rb = new RequestBuilder(rootUrl, getApiCorporategroupV1Id$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CorporateGroupModel>;
    })
  );
}

getApiCorporategroupV1Id$Json.PATH = '/private/v1/corporate-groups/{id}';
